export enum DateFormat {
  /** 2026-07-11 */
  DATE = 'YYYY-MM-DD',
  /** 2026-07-11 14:30:00 */
  DATE_TIME = 'YYYY-MM-DD HH:mm:ss',
  /** 2026-07-11 14:30 */
  DATE_TIME_SHORT = 'YYYY-MM-DD HH:mm',
  /** 2026-07 */
  MONTH = 'YYYY-MM',
  /** 11.07.2026 */
  DATE_DOT = 'DD.MM.YYYY',
  /** 11.07.2026 14:30 */
  DATE_TIME_DOT = 'DD.MM.YYYY HH:mm',
  /** 14:30 */
  TIME = 'HH:mm',
  /** 14:30:00 */
  TIME_WITH_SECONDS = 'HH:mm:ss',
  /** Şənbə, 11 iyul 2026 14:30 (locale-aware) */
  LOCALIZED = 'LLLL',
}

export const Constants = {
  DATE: DateFormat.DATE,
  DATE_TIME: DateFormat.DATE_TIME,
  DATE_TIME_DOT: DateFormat.DATE_TIME_DOT,
};

export const ErrorAudioUrls = {
  alert: '/audio/alert.mp3',
  already_accepted: '/audio/already_accepted_error.mp3',
  different_branch_id: '/audio/different_branch_error.mp3',
  null_list: '/audio/null_list_error.wav',
};
